import styled from "styled-components";
import { NOTICE_COLORS } from "styles/colors";
import { DefaultBarWrapper } from "./NoticeBar";
import { useAppSelector } from "redux/hooks";
import TinyButton from "components/atoms/buttons/TinyButton";
import { ReleaseVersion } from "api/interfaces/releaseInterface.interface";

interface Props {}

export default function VersionRefreshBar(props: Props): JSX.Element {
  const themeMode = useAppSelector((state) => state.theme.theme);
  const release: ReleaseVersion = useAppSelector(
    (state) => state.notice.release
  );
  return (
    <Wrapper
      color={
        themeMode === "light" ? NOTICE_COLORS.LIGHTCOOKIE : NOTICE_COLORS.COOKIE
      }
    >
      New version of myDW Web Portal is available. (v{release.installedVersion})
      <TinyButton
        label={`Refresh to Update v${release.latestVersion}`}
        onClickBtn={() => {
          window.location.reload();
        }}
        data-testid="element-version-refresh-bar-tsx-element-tiny-button-reload"
      />
    </Wrapper>
  );
}

const Wrapper = styled(DefaultBarWrapper)`
  /* justify-content: space-between; */
  gap: 10px;
  /* padding: 10px; */
  font-weight: 500;
  color: ${({ theme }) => theme.COLORS.WHITE};

  button {
    line-height: normal;
  }
`;
